var MultiPassMaterialBase = (function () {
    function MultiPassMaterialBase() {
    }
    return MultiPassMaterialBase;
}());
export { MultiPassMaterialBase };
